import React from 'react';
import { css } from '@emotion/core';
import Dropdown from '../common/Dropdown';
import IconPng from '../common/IconPng';
import { fontSize } from '../../constants';

const { Option } = Dropdown;

const CurrencyDropdown = props => {
  const { small, onChange, defaultValue, mobileLayout,isBetaUser } = props;

  const options = [
    {
      text: '$',
      value: JSON.stringify({currency : 'USD'}),
      icon: 'flags/round/us/us',
      disabled: false,
      hidden:false
    },
    {
      text: '£',
      value: JSON.stringify({currency : 'GBP'}),
      icon: 'flags/round/uk/uk',
      disabled: false,
      hidden:false
    },
    {
      text: 'C$',
      value: JSON.stringify({currency : 'CAD'}),
      icon: 'flags/round/canada/canada',
      disabled: false,
      hidden:false
    },
    {
      text: '€',
      value: JSON.stringify({currency : 'EUR',sourceMarketplace : 'AZ_DE'}),
      icon: 'flags/round/germany/germany',
      disabled: false,
      hidden:false
    },
    {
      text: '€',
      value: JSON.stringify({currency : 'EUR',sourceMarketplace : 'AZ_IT'}),
      icon: 'flags/round/italy/italy',
      disabled: false,
      hidden:!isBetaUser
    },
    {
      text: '€',
      value: JSON.stringify({currency : 'EUR',sourceMarketplace : 'AZ_FR'}),
      icon: 'flags/round/france/france',
      disabled: false,
      hidden:false
    },
    {
      text: '€',
      value: JSON.stringify({currency : 'EUR',sourceMarketplace : 'AZ_ES'}),
      icon: 'flags/round/spain/spain',
      disabled: false,
      hidden:false
    },
  ];

  return (
    <Dropdown
      onChange={onChange}
      defaultValue={defaultValue}
      value={defaultValue}
      height={small ? '22px' : '32px'}
      borderRadius="16px !important"
      mobileLayout={mobileLayout}
      css={css`
        & div.ant-select-selection-selected-value {
          overflow: visible;
        }
      `}
    >
      {options.map(option => (
        <Option
          value={option.value}
          key={option.value}
          disabled={option.disabled}
          hidden={option.hidden}
        >
          <IconPng
            type={option.icon}
            size={small ? 25 : 28}
            marginTop="-3px"
            marginLeft={small ? '-13px' : '-15px'}
            marginRight={small ? undefined : '-4px'}
            fullSizeIcon={option.fullSizeIcon}
          />
          <span
            css={css`
              font-size: ${small ? fontSize.small : '13px'};
            `}
          >
            {option.text}
          </span>
        </Option>
      ))}
    </Dropdown>
  );
};

export default CurrencyDropdown;
